export default "__VITE_ASSET__DnRyTqx6__"